import { TagHeartIcon } from './TagHeartIcon';

/**
 * author: Google
 * id 2D9E735C-EA23-4EB2-9AC4-C92D69218577
 * name tag-heart
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-heart.svg
 * tags
 */
export const LoyaltyIcon = TagHeartIcon;
export default LoyaltyIcon